import { styled } from 'styled-components';

import { EOrderStatus } from '@/types/orders';

import { Button } from '@/shared/ui/button';
import { mq } from '@/shared/ui/styled';

export const ButtonWrapper = styled(Button)`
    height: 32px;
    color: #1f2547;
    ${mq.lt.md} {
        height: 44px;
        width: 100%;
    }
`;

export const Wrapper = styled.div<{ $status: EOrderStatus }>`
    display: flex;
    flex-grow: 1;
    align-items: end;
    gap: 10px;
    justify-content: flex-start;
    ${mq.lt.md} {
        margin: ${({ $status }) => ($status === 'closed' ? '10px 0 0 0' : '10px 0')};
        flex-direction: column;
    }
`;
